
if (document.getElementById("shareBtn")) {
const shareBtn = document.getElementById('shareBtn');

shareBtn.addEventListener('click', () => {
    shareBtn.classList.toggle('open');
});

};